import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import plannedDefectDataStore from "../../../store/plannedDefectData";
import { authStore } from "../../../store/authStore";
import defectCardsStore from "../../../store/defectCards";
import DefectTable from "./table";
import { IDefectDataProps } from "..";
import { IButton } from "../../../ui-kit";

const PlannedDefectData: FC<IDefectDataProps> = observer(
  ({ columns, openDefectCard }) => {
    const { data, paginator, isLoading, sorter, allData } =
      plannedDefectDataStore;
    const { defectNotify } = authStore;
    const { defectAgreedIsSending } = defectCardsStore;

    const openDefect = (id: string) => {
      if (openDefectCard) {
        openDefectCard(id, columns?.planned);
      }
    };

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    useEffect(() => {
      allData();
    }, [
      paginator.page,
      paginator.perPage,
      plannedDefectDataStore.filter.filterItems,
      sorter.changingKey,
    ]);

    useEffect(() => {
      if (defectAgreedIsSending.value) {
        allData();
      }
    }, [
      defectAgreedIsSending.value,
      paginator.page,
      paginator.perPage,
      plannedDefectDataStore.filter.filterItems,
      sorter.changingKey,
    ]);

    const parseChildren = (col) => {
      return {
        ...col,
        children:
          col.children?.length > 0
            ? col.children
                .filter((col) => columns.visibleCols.keys.includes(col.key))
                .map(parseChildren)
            : null,
      };
    };

    const cols = columns.columns
      .filter((col) => columns.visibleCols.keys.includes(col.key))
      .map(parseChildren);

    const rowSelection = defectNotify
      ? {
          selectedRowKeys,
          onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
          },
        }
      : null;

    const handleClickDefectAgreed = () => {
      // подтверждение
      const request = {
        ids: selectedRowKeys,
        isValid: true,
      };
      defectCardsStore.sendDefectAgreedAll(request);
      setSelectedRowKeys([]);
    };

    // const rowSelection = defectNotify ? {
    //   selectedRowKeys: plannedDefectDataStore.selectedRows.keys,
    //   onChange: (selectedRowKeys) => {
    //     plannedDefectDataStore.selectedRows.setKeys([ ...selectedRowKeys ]);
    //   },
    // } : null;

    return (
      <>
        {authStore && defectNotify && (
          <IButton
            onClick={handleClickDefectAgreed}
            disabled={
              selectedRowKeys.length === 0 || defectAgreedIsSending.value
            }
          >
            Подтвердить
          </IButton>
        )}
        <DefectTable
          columns={cols}
          dataSource={data}
          paginator={paginator}
          sorter={sorter}
          isLoading={isLoading.value}
          planned
          rowSelection={rowSelection}
          openDefect={openDefect}
        />
      </>
    );
  },
);

export default PlannedDefectData;
